import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import disableBrowserBackButton from "disable-browser-back-navigation";
import { Alert } from "react-bootstrap";
import xss from "xss";

import { Link, useNavigate } from "../utils/components/router";
import Timeout from "../utils/components/Timeout";
import { PartialBasketItem, BackToStartButton, ShippingChoice, KonditionenSwitch } from "../partial";
import { pageActions, messageActions, basketActions, metalsActions, currenciesActions, kundenActions } from "../actions";
import { warningForSellAboveLimitNachweis, warningAboveLimitGeneral, sumLimitForSellNachweis, warningAboveLimitGeneralCustomer } from "../utils/enums/CONSTANTS";
import { warningForSellAboveLimitDeuba } from "../utils/enums/CONSTANTS";
import { responseFunctions, console, sendError } from "../utils/functions";
import { RAGE_RIGHT } from "../utils/enums/RAGE_RIGHT";
import { ArrowBackIcon, ArrowForwardIcon } from "../utils/components/icons";
import CONFIG from "../config";
import { RESPONSE_HEADER } from "../utils/enums";
import ShippingChoiceSearch from "../partial/ShippingChoiceSearch";
import ServiceContactInfo from "../partial/ServiceContactInfo";

let locked = false;
const catalogActions = CONFIG.getShopConfig({
  edelmetall: metalsActions,
  sorten: currenciesActions,
  default: {}
});

class Cart extends Component {
  constructor(props) {
    super(props);
    this.onEdit = this.onEdit.bind(this);
    this.handleLoginForCondition = this.handleLoginForCondition.bind(this);
    this.handleCommit = this.handleCommit.bind(this);
    this.handleBackToOverview = this.handleBackToOverview.bind(this);
    this.renderEdelmetallTableHeader = this.renderEdelmetallTableHeader.bind(this);
    this.renderSortenTableHeader = this.renderSortenTableHeader.bind(this);
  }

  state = {
    activeItemIndex: 0,
    setActiveItemIndex: 0,
    didShowWarning: false,
    isOnEdit: [],
    isShippingEdited: false,
    isBezahlButtonClicked: false
  };

  componentDidMount = async () => {
    disableBrowserBackButton();
    if (this.props.configStorage.isAnkaufShop() && this.props.basketStorage.hasFilialen() && !this.props.mandantStorage.ablieferadresseAnkauf()) {
      this.props.dispatch(basketActions.setSelectedFiliale(this.props.basketStorage.filialen[0]));
    } else {
      this.props.dispatch(basketActions.setSelectedFiliale(null));
    }

    if ((!this.props.configStorage.isAnkaufShop() && this.props.basketStorage.isTooHigh()) ||
        (this.props.configStorage.isAnkaufShop() && this.props.basketStorage.isTooHighForSell())) {      
      this.showLimitWarning(
        (this.props.configStorage.isKundenShop() ? warningAboveLimitGeneralCustomer : warningAboveLimitGeneral), 
        this.props.basketStorage.getMaxSumText()
      );           
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.basketStorage.numItems() === 0) {
      this.props.dispatch(pageActions.setOverviewPage());
    }   
  }

  onEdit(index, value) {
    if (value === true || value === false) {
      this.setState(prev => {
        // copy array from prev state
        const isOnEdit = prev.isOnEdit.slice();
        isOnEdit[index] = value;
        return { isOnEdit: isOnEdit, isBezahlButtonClicked: false };
      });
    } else if (index === true || index === false) {
      this.setState({ isShippingEdited: index });
    }
  }

  renderBasketItems = () => {
    let items = [];
    for (let i = 0; i < this.props.basketStorage.items.length; i++) {
      if (this.state.isOnEdit.length === i) {
        this.state.isOnEdit.push(false);
      }
      let itemDue;
      if (this.props.basketStorage.items[i]) {
        itemDue = this.props.basketStorage.items[i].positionDues.clone().toFormat();
      }
      items.push(
        <PartialBasketItem
          key={i}
          index={i}
          isOnEdit={this.state.isOnEdit[i]}
          onEdit={this.onEdit}
          item={this.props.basketStorage.items[i]}
          itemDue={itemDue}
          isBezahlButtonClicked={this.state.isBezahlButtonClicked}
        />
      );
    }
    return items;
  };

  async getKatalogData() {
    let catalogRequestData = this.props.configStorage.getRequestData("catalog");
    let basedataRequestData = this.props.configStorage.getRequestData("basedata");

    await axios.all([
      axios[basedataRequestData.request.type](
        basedataRequestData.url,
        basedataRequestData.json,
        basedataRequestData.request.config
      ),
      axios[catalogRequestData.request.type](
        catalogRequestData.url,
        catalogRequestData.json,
        catalogRequestData.request.config
      )
    ]).then(
      axios.spread((basedata, catalog) => {
        let result = responseFunctions.checkAllResponses([basedata, catalog]);
        if (result.status === "OK") {
          let katalog = CONFIG.getShopConfig({
            edelmetall: catalog.data.edelmetallKatalog,
            sorten: catalog.data.sortenKurse
          });

          this.props.dispatch(
            catalogActions.setData(
              basedata.data,
              katalog
            )
          );
        } else {
          throw new Error({ error: result });
        }
      })
    )
      .catch(error => {
        let errorMessage;
        if (!error.error || !error.response) {
          errorMessage = xss(error.message);
          sendError(error, "cart");
        } else {
          errorMessage = xss(
            error.error && error.error.status === "ERROR"
              ? error.error.message
              : responseFunctions.getErrorResponseMessage(error)
          );
          sendError(new Error(errorMessage), "cart");

        }
        this.props.navigate("/error", { errorMsg: errorMessage });
      });
  }

  showLimitWarning(message, value) {
    const warningMessage = message.replace(
      "{value}",
      String(value)
    );

    this.props.dispatch(
      messageActions.showWarningMessage(
        this.props.configStorage.getHtmlId(),
        ".ser-carttop",
        warningMessage,
        "50%",
        " 25%"
      )
    );
  }

  handleCommit() {
    const isEditOpen = this.state.isOnEdit.reduce((prev, edit) => prev || !!edit, false);
    if (isEditOpen || this.state.isShippingEdited) {
      this.setState({ isBezahlButtonClicked: true });
      return;
    }
    let { basketStorage, configStorage, metalsStorage, currenciesStorage, kundenStorage, mandantStorage } = this.props;
    let shopStorage = CONFIG.getShopConfig({
      edelmetall: metalsStorage,
      sorten: currenciesStorage
    });

    let textFilialWahl = "Bitte wählen Sie die Filiale aus, wo Sie Ihre Bestellung abholen möchten.";
    let textAblieferFilialWahl = "Bitte wählen Sie die Filiale aus, wo Sie Ihre Ware abliefern möchten.";
    let textVersandOptionWahl = "Bitte wählen Sie eine Versandoption aus.";

    if (locked) {
      return;
    } else if ((!configStorage.isAnkaufShop() && basketStorage.isTooHigh()) ||
                (configStorage.isAnkaufShop() && basketStorage.isTooHighForSell())) {      
      this.showLimitWarning((configStorage.isKundenShop() ? warningAboveLimitGeneralCustomer : warningAboveLimitGeneral), basketStorage.getMaxSumText());      
      return false;
    } else if (CONFIG.isSortenShop() && configStorage.isAnkaufShop() && basketStorage.showNachweisWarning() && !this.state.didShowWarning) {      
      this.showLimitWarning(warningForSellAboveLimitNachweis, sumLimitForSellNachweis);
      this.setState({ didShowWarning: true });
      return false;
    } else if (CONFIG.isEdelmetallShop() && configStorage.isDeuBa() && configStorage.isAnkaufShop() && basketStorage.isTooHighForDeuBaEMSell() && !this.state.didShowWarning) {
          this.props.dispatch(
            messageActions.showWarningMessage(
              configStorage.getHtmlId(),
              ".ser-carttop",
              warningForSellAboveLimitDeuba,
              "50%",
              " 25%"
            )
          );
          this.setState({ didShowWarning: true });
          return false;
    } else if (
      basketStorage.doShip === "no" && !configStorage.isAnkaufShop() &&
      (
        !basketStorage.selectedFiliale ||
        basketStorage.selectedFiliale.value === "NONE"
      )
    ) {
      this.props.dispatch(
        messageActions.showMessage(
          configStorage.getHtmlId(),
          ".ser-shipping",
          basketStorage.hasFilialen() ? textFilialWahl : textVersandOptionWahl
        )
      );
    } else if (
      configStorage.isAnkaufShop() && mandantStorage.ablieferadresseAnkauf() &&
      (
        !basketStorage.selectedFiliale ||
        basketStorage.selectedFiliale.value === "NONE"
      )
    ) {
        this.props.dispatch(
          messageActions.showMessage(
            configStorage.getHtmlId(),
            ".ser-shipping",
            textAblieferFilialWahl
          )
        );
    } else {
      if (basketStorage.doShip === "yes") {
        this.props.dispatch(basketActions.setSelectedFiliale(null));
      }
      locked = false;
      let data = basketStorage.toJSONForCart(
        configStorage.getSessionId(),
        shopStorage.getCatalogTimestamp(),
        kundenStorage.getKunde().id
      );
      let requestData = this.props.configStorage.getRequestData("warenkorb", "post", data);
      axios[requestData.request.type](requestData.url, requestData.json)
        .then(async response => {
          const deltaKey = CONFIG.getShopConfig({
            edelmetall: "edelmetallWarenkorbDelta",
            sorten: "sortenWarenkorbDelta"
          });
          const listDeltaKey = CONFIG.getShopConfig({
            edelmetall: "listEdelmetallWarenkorbDelta",
            sorten: "listSortenWarenkorbDelta"
          });
          if (!response) response = {};
          if (!response.data) response.data = {};
          if (
            (
              response.data[deltaKey] &&
              response.data[deltaKey].length > 0
            ) ||
            (
              response.data[listDeltaKey] &&
              response.data[listDeltaKey].length > 0
            ) ||
            response.data.errorStatus === "DELTA" ||
            (
              response.data.header &&
              response.data.header.status === RESPONSE_HEADER.STATUS.DELTA
            )
          ) {
            // this is a delta resopnse
            console.log(response);
            locked = false;
            let status = responseFunctions.checkDeltaResponse(response);
            if (status.status === "WARN") this.setState({ deltaMessage: xss(status.message) });
            await this.props.dispatch(basketActions.rebuildForApproval(response.data));
            if (basketStorage.isError()) {
              let msg = basketStorage.getError();
              this.props.dispatch(pageActions.setDeltaErrorPage(msg));
            } else if (status.status === "ERROR") {
              this.props.dispatch(pageActions.setDeltaErrorPage(xss(status.message)));
            } else {
              this.getKatalogData();
              this.forceUpdate();
            }
          } else {
            const warenkorbKey = CONFIG.getShopConfig({
              edelmetall: "edelmetallWarenkorb",
              sorten: "sortenWarenkorb"
            });

            if (response.data[warenkorbKey] && response.data[warenkorbKey].angebotsNr !== null) {
              console.log("warenkorbId", this.props.basketStorage.warenkorbId);
              await this.props.dispatch(basketActions.setWarenkorbId(response.data[warenkorbKey].angebotsNr));
              let dataForOrder = basketStorage.toJSONForOrder(
                configStorage.getSessionId(),
                shopStorage.getCatalogTimestamp(),
                response.data[warenkorbKey].angebotsNr
              );
              console.log("warenkorbId", this.props.basketStorage.warenkorbId);
              await this.props.dispatch(basketActions.setDataForOrder(dataForOrder));
              console.log("warenkorbId", this.props.basketStorage.warenkorbId);
            }
            this.setState({ didShowWarning: false });

            if (this.props.configStorage.isVerseNeo() || this.props.configStorage.isDeuBa()) {
              let kunde = this.props.kundenStorage.getKunde();              
              if (this.props.configStorage.isKundenShop()) {
                let weiterleitung = this.props.basketStorage.doShip === "yes" ? CONFIG.LINK_KUNDEN_ADDRESSE_MA : CONFIG.LINK_FILIALELIEFERUNG;
                this.props.navigate(weiterleitung);
              } else {
                this.weiterleitung(null, kunde.id);
              }
            } else {
              if (this.props.configStorage.isKundenShop()) {
                this.props.navigate(CONFIG.LINK_KUNDE_LOGIN);
              } else {
                this.props.navigate(CONFIG.LINK_MITARBEITER_ADD_KUNDEN);
              }
            }
          }
        })
        .catch(error => {
          sendError(error, "cart");
          let msg = xss(error.message ? error.message : error.data);
          // TODO fix condition for PreisDiff error
          if (error.request && error.request.isPreisDiff) {
            msg = CONFIG.getShopConfig({
              edelmetall: "Es gibt Preisdifferenzen. Bitte klicken Sie auf den unteren Link, um neue Preise zu laden.",
              sorten: "Es gibt Preisdifferenzen, bitte aktualisieren Sie die Kurse über den unteren Link."
            });
          }
          this.props.dispatch(pageActions.setErrorPage(msg));
        });
    }
  }  

  weiterleitung = async (e, kundenId) => {
    if (e) {
      e.preventDefault();
      if (!kundenId && e.target.dataset.id) {
        kundenId = Number(e.target.dataset.id);
      }
    }
    //#AnpassungKunde
    let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde");
    requestDataKundenEntry.url = requestDataKundenEntry.url + kundenId;
    const kunde = await this.props.dispatch(kundenActions.fetchEntry(requestDataKundenEntry))
      .catch(err => {
        console.error("KundenRecordDataMa weiterleitung", err);
        sendError(err, "cart");
        this.setState({ error: err });
      });
    if (kunde) {
      let weiterleitung = this.props.basketStorage.doShip === "yes" ? CONFIG.LINK_KUNDEN_ADDRESSE_MA : CONFIG.LINK_FILIALELIEFERUNG;
      this.props.navigate("../" + weiterleitung);
    }
  };

  handleBackToOverview() {
    this.props.dispatch(pageActions.setOverviewPage());
  }

  handleLoginForCondition(e) {
    if (!e || !e.target) return;
    e.preventDefault();
    this.props.navigate(CONFIG.LINK_MITARBEITERLOGIN_KONDITION);
  }

  renderEdelmetallTableHeader() {
    let rightStorage = this.props.rightStorage;
    let configStorage = this.props.configStorage;
    let basketStorage = this.props.basketStorage;
    return <thead>
      <tr>
        <th className="text-start ps-one">Produkt</th>        
        <th className="text-end">Stückpreis</th>
        <th className="text-center">Stückzahl</th>
        <th className={(
          rightStorage.currentRight.includes(RAGE_RIGHT.RAGE_BERATER_ZWEI) && basketStorage.editCondition
            ? " text-center"
            : " text-end"
        )}
        >
          Konditions&shy;änderung/Gebühr
        </th>
        <th className="text-end column-1">MwSt.</th>
        <th className="text-end col-12">Produktpreis brutto inkl. Konditions&shy;änderung/Gebühr</th>
        <th aria-hidden="true">&nbsp;</th>
        {configStorage.isMaShop()
          ? <th><span className="aria-visible">Aktionen</span></th>
          : null
        }
      </tr>
    </thead>;
  }

  renderSortenTableHeader() {
    let configStorage = this.props.configStorage;
    return <thead>
      <tr>
        <th className="text-start ps-one">Produkt</th>
        <th className="text-end">Kurs</th>
        <th className="text-center">Betrag</th>
        {!configStorage.isAnkaufShop()
          ? <th className="text-end column-1">Stückelung</th>
          : null
        }
        <th className="text-end">Konditions&shy;änderung/Gebühr</th>
        <th className="text-end col-12">Gegenwert inkl. Konditions&shy;änderung/Gebühr</th>
        {configStorage.isMaShop()
          ? <th><span className="aria-visible">Aktionen"</span></th>
          : null
        }
      </tr>
    </thead>;
  }

  render() {
    let basketStorage = this.props.basketStorage;
    let configStorage = this.props.configStorage;
    let authenticate = this.props.authenticationStorage;
    let gebuehren = CONFIG.getShopConfig({
      edelmetall: basketStorage.positionDuesSum,
      sorten: basketStorage.dues
    }).clone();
    let shipping = basketStorage.shipping.clone();
    if (configStorage.isAnkaufShop()) { // display as positive values
      // gebuehren = gebuehren.multiply(-1);
      shipping = CONFIG.getShopConfig({
        edelmetall: shipping.multiply(-1),
        sorten: shipping.set(0)
      });
    }

    const renderTableHeader = CONFIG.getShopConfig({
      edelmetall: this.renderEdelmetallTableHeader,
      sorten: this.renderSortenTableHeader
    });
    console.log("konditionen", authenticate.isUserSignedIn, basketStorage.editCondition, configStorage.isMaShop());

    return (
      <div className="ser-cart pb-one">
        <h2 className="ser-appheadline">Warenkorb</h2>
        <Timeout />
        <section className="ser-carttop" aria-label="Überblick">
          <div className="ser-cartcaption ser-textpanel ser-iblock">
            Ihre {CONFIG.SHOP_NAME}auswahl auf einen Blick{" "}
          </div>
          <div className="ser-cartoverview ser-textpanel ser-iblock" >
            <span>Artikel: {basketStorage.items.length}</span>{" "}
            <span className="ser-mblock">Preis: {basketStorage.sum.toEuro()}</span>
          </div>
        </section>
        {basketStorage.dirty
          ? <div className="ser-cartmsg ser-textpanel">
            Leider haben sich in der Zwischenzeit einige Preise geändert.
            <br />
            Bitte beachten Sie die rot markierten Positionen und klicken Sie
            anschließend erneut auf „{!configStorage.isAnkaufShop() ? "Zur Bestellung" : "Zum Ankauf"}“ um die Bestellung
            abzuschließen.
          </div>
          : null
        }
        <section className="bg-white table-scroll ser-table" aria-label="Bestellte Produkte" >
          <table className="table table-responsive table-striped" aria-label="Tabelle der Produkte">
            {renderTableHeader()}
            <tbody>
              {this.renderBasketItems()}
            </tbody>
          </table>
        </section>
        {!authenticate.isUserSignedIn && basketStorage.editCondition && configStorage.isMaShop()
          ? (
            <div className="ser-cartbot btn-toolbar justify-content-between align-items-center mb-one">
              <KonditionenSwitch />
              <Link
                onClick={this.handleLoginForCondition}
                className="ser-commit ser-iblock btn-primary"
                to="#"
              >
                Konditionsanpassung
                <ArrowForwardIcon />
              </Link>
            </div>
          )
          : null
        }
        {configStorage.isMaShop() && (!basketStorage.editCondition || authenticate.isUserSignedIn)
          ? < div className="ser-cartbot d-flex align-items-center">
            <KonditionenSwitch />
          </div>
          : null
        }
        {!configStorage.isAnkaufShop()
          ? <section aria-label="Versandoptionen">
            {!this.props.mandantStorage.searchLieferadresseAktiv() ?
              <ShippingChoice /> : <ShippingChoiceSearch /> 
            }                                    
          </section>
          : null
        }
        {configStorage.isAnkaufShop() && this.props.mandantStorage.ablieferadresseAnkauf()
          ? <section aria-label="Ablieferadresse" className="mt-3 ser-shipping">
            {!this.props.mandantStorage.searchAblieferadresseAktiv() ?
              <ShippingChoice /> : <ShippingChoiceSearch /> 
            }
          </section>
          : null
        }
        <section className="ser-summary ser-textpanel" aria-label="Zusammenfassung">
          <div className="ser-section">
            <div className="ser-rightbox">
              <div className="ser-iblock ser-first">
                {CONFIG.getShopConfig({
                  edelmetall: "Produktpreis",
                  sorten: "Gegenwert"
                })}{" "}netto:
              </div>
              <div className="ser-iblock ser-second">
                {basketStorage.sumNetto.toEuro()}
              </div>
            </div>
           {!shipping.isZero()
              ? (
                <div className="ser-grey ser-rightbox">
                <div className="ser-iblock ser-first">Versandkosten:</div>
                <div className="ser-iblock ser-second">
                                    {shipping.toEuro()}
                </div>
                </div>
                              )
              : null
            }
            {basketStorage.hasDues
              ? (
                <div className="ser-grey ser-rightbox">
                  <div className="ser-iblock ser-first ser-addtaxes">
                    Konditions&shy;änderungen/Gebühren:
                  </div>
                  <div className="ser-iblock ser-second">
                    {gebuehren.toEuro()}
                  </div>
                </div>
              )
              : null
            }
          </div>
          {CONFIG.isEdelmetallShop()
            ? (
              <div className="ser-section-big">
                <div className="ser-rightbox">
                  <div className="ser-iblock ser-first">Zwischensumme:</div>
                  <div className="ser-iblock ser-second">
                    {basketStorage.sumBeforeTax.toEuro()}
                  </div>
                </div>
                <div className="ser-grey ser-rightbox">
                  <div className="ser-iblock ser-first">MwSt.*:</div>
                  <div className="ser-iblock ser-second">
                    {basketStorage.sumTaxes.toEuro()}
                  </div>
                </div>
              </div>
            )
            : null
          }
          <div className="ser-rightbox">
            <div className="ser-iblock ser-first ser-overall">Endsumme:</div>
            <div className="ser-iblock ser-second ser-overall ser-red">
              {basketStorage.sum.toEuro()}
            </div>
          </div>
        </section>
        {this.state.deltaMessage
          ? <Alert variant="danger" className="mt-one">
            {this.state.deltaMessage}
          </Alert>
          : null
        }
        <div className="ser-cartbot btn-toolbar justify-content-between">
          {!basketStorage.locked
            ? (
              <button type="button"
                onClick={this.handleBackToOverview}
                className="ser-back btn-link justify-content-start"
              >
                <ArrowBackIcon />
                zurück
              </button>
            )
            : null
          }
          <BackToStartButton />
          {configStorage.isAnkaufShop() || basketStorage.hasShippingChoice || basketStorage.hasFilialChoice
            ? (
              <button type="button"
                onClick={this.handleCommit}
                className="btn-primary ser-commit ser-iblock"
                disabled={configStorage.isLoadingMaKond()}
              >
                {!configStorage.isAnkaufShop() ? "Zur Bestellung" : "Zum Ankauf"}
                <ArrowForwardIcon />
              </button>
            )
            : null
          }
        </div>
        {CONFIG.isEdelmetallShop()
          ? <div className="ser-carthint pt-one">
            * inkl. MwSt. auf Konditionsänderungen/Gebühren und Direktversandkosten von
            MwSt.-pflichtigen Produkten
          </div>
          : null
        }        
        <div className="d-md-none buffer-area"></div>        
        <ServiceContactInfo/>
      </div>      
    );
  }
}

export default connect(store => {
  return {
    authenticationStorage: store.authenticationStorage,
    basketStorage: store.basketStorage,
    messageStorage: store.messageStorage,
    configStorage: store.configStorage,
    metalsStorage: store.metalsStorage,
    currenciesStorage: store.currenciesStorage,
    rightStorage: store.rightStorage,
    kundenStorage: store.kundenStorage,
    mandantStorage: store.mandantStorage,
  };
})((props) => {
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <Cart navigate={contextNavigate} {...props} />;
});
